import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AirActionTrackingLocation } from '../types';
import META from './useTrackDuplicatedCanvas.meta';

export type TrackDuplicatedCanvasParams = {
  canvasId: string;
  sourceCanvasId: string;
  location: AirActionTrackingLocation;
  boardId?: string;
};

export const useTrackDuplicatedCanvas = () => {
  const { track } = useAnalyticsUtilities();

  const trackDuplicatedCanvas = useCallback(
    (params: TrackDuplicatedCanvasParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackDuplicatedCanvas };
};
